import React from 'react'
import { compose } from 'recompose'
import { translate } from 'react-i18next'
// import PropTypes from 'prop-types'
import moment from 'moment'
import 'moment/locale/fr'
import 'moment/locale/nl'
import * as translationService from './../../services/translationService'
import * as networkService from './../../services/networkService'
import { getFullAddressForProperty, getBrokerForProperty } from './../../utils/property'

import {
  DisplayText,
  Spinner,
  ResourceList,
  Stack,
  Caption,
  DisplayCurrency,
  ErrorText,
  EmptyState,
} from './../../components'
import { dump } from '../../services/debugService'

export const HistoryView = () => {
  const [isLoading, setLoading] = React.useState(true)
  const [applications, setApplications] = React.useState([])
  const [error, setError] = React.useState()

  React.useEffect(() => {
    fetchApplications()
  }, [])

  const fetchApplications = async () => {
    try {
      const applicattionData = await networkService.getApplications()
      const applications = applicattionData.data.filter(application => !!application.property).map(application => ({
        ...application,
        date: application.providedAt,
        propertyAddress: getFullAddressForProperty(application.property),
        propertyId: application.property.id,
        price: application.property.price.toString(),
        broker: getBrokerForProperty(application),
      }))
      setLoading(false)
      setApplications(applications)
    } catch (err) {
      dump(err)
    }
  }

  const removeFromBroker = async applicationId => {
    resetError()
    try {
      await networkService.removeApplicationAtBroker(applicationId)
      fetchApplications()
    } catch (error) {
      const errorObj = error.response && error.response.data && error.response.data.error
      setError(errorObj)
    }
  }

  const resetError = () => {
    setError()
  }

  return (
    <React.Fragment>
      {error && <ErrorText>{error.message}</ErrorText>}
      {isLoading && <Spinner />}
      {!isLoading &&
        (applications.length ? (
          <ResourceList
            items={applications}
            renderItem={item => {
              let actions = []

              if (item.pdfUrl) {
                actions = [
                  ...actions,
                  {
                    content: translationService.downloadPDF(),
                    onClick: () => (window.location = item.pdfUrl),
                    primary: false,
                    plain: true,
                  },
                ]
              }
              actions = [
                ...actions,
                {
                  content: translationService.profileResendApplication(item.step),
                  url: `/property/${item.propertyId}/opnieuw`,
                  primary: false,
                  plain: true,
                },
              ]

              if (item.removedByBrokerAt) {
                actions.push({
                  content: translationService.intakeRemoveByBroker(),
                  // onClick: () => {},
                  primary: false,
                  plain: true,
                  disabled: true,
                })
              } else {
                if (moment(item.providedUntil).isBefore(new Date())) {
                  actions.push({
                    content: translationService.intakeRemoveApplicationPending(),
                    primary: false,
                    plain: true,
                    disabled: true,
                  })
                } else {
                  actions.push({
                    content: translationService.intakeRemoveApplication(),
                    onClick: () => removeFromBroker(item.id),
                    primary: false,
                    plain: true,
                  })
                }
              }

              const renderName = () => {
                if (item.broker.name) {
                  return item.broker.name
                }

                return item.property.ownerships
                  .map(owner => [owner.account.firstname, owner.account.lastname].join(' '))
                  .join(' & ')
              }

              return (
                <ResourceList.Item actions={item.property.rentable && actions} subdued={!item.property.rentable}>
                  <Stack spacing="tight" vertical={true} className="d-md-flex align-items-center">
                    <DisplayText size="extraSmall">
                      {moment(item.date).format('L LT')}: {renderName()}
                    </DisplayText>
                    <Caption>
                      {item.propertyAddress} - <DisplayCurrency value={Number(item.price)} />
                    </Caption>
                  </Stack>
                </ResourceList.Item>
              )
            }}
          />
        ) : (
          <EmptyState heading={translationService.mySubmissionHistoryEmptyTitle()}>
            <p>{translationService.mySubmissionHistoryEmptyText()}</p>
          </EmptyState>
        ))}
    </React.Fragment>
  )
}
export default compose(translate('translations'))(HistoryView)



// WEBPACK FOOTER //
// ./src/views/Profile/History.js